module.exports = __webpack_public_path__ + "static/media/menu-icon-legacy.84224140.png";